// @need-translate
import {t} from '../../../../common/getTranslations';
import {TicketKind, TicketType} from '../../../../graphql/generated/types';
import {getTicketKindByTicketType} from './getTicketKindByTicketType';

export function getTicketName(ticketType: TicketType): string {
  let ticketTitle = '';
  switch (ticketType) {
    case TicketType.BuyNewCustomerGift:
      ticketTitle = t('common_ticket_possession_new');
      break;
    case TicketType.BuyWaitFree:
      ticketTitle = t('common_ticket_possession_wuf');
      break;
    case TicketType.BuyTodayGift:
    case TicketType.BuyGiftFree:
      ticketTitle = t('common_ticket_possession_gift');
      break;
    case TicketType.BuyEvent:
    case TicketType.BuyCoupon:
    case TicketType.BuyCampaign:
      ticketTitle = t('common_ticket_possession_free');
      break;
    /** @deprecated */
    case TicketType.BuyWaitFreePlus:
      ticketTitle = '레전드패스 소장권';
      break;
    case TicketType.RentNewCustomerGift:
      ticketTitle = t('common_ticket_rental_new');
      break;
    case TicketType.RentWaitFree:
      ticketTitle = t('common_ticket_rental_wuf');
      break;
    case TicketType.RentTodayGift:
    case TicketType.RentGiftFree:
      ticketTitle = t('common_ticket_rental_gift');
      break;
    case TicketType.RentEvent:
    case TicketType.RentCoupon:
    case TicketType.RentCampaign:
      ticketTitle = t('common_ticket_rental_free');
      break;
    /** @deprecated */
    case TicketType.RentWaitFreePlus:
      ticketTitle = '레전드패스 대여권';
      break;
    case TicketType.BuySet:
    case TicketType.RentSet:
      ticketTitle = '세트이용권패키지';
      break;
    case TicketType.BuyCashSingle:
      ticketTitle = '즉납형단일소장권';
      break;
    case TicketType.BuyCashDiscountSingle:
      ticketTitle = '즉납형단일할인소장권';
      break;
    case TicketType.RentCashSingle:
      ticketTitle = '즉납형단일대여권';
      break;
    case TicketType.RentCashDiscountSingle:
      ticketTitle = '즉납형단일할인대여권';
      break;
    default:
      ticketTitle =
        getTicketKindByTicketType(ticketType) === TicketKind.Own
          ? t('common_ticket_possession')
          : t('common_ticket_rental');
      break;
  }
  return ticketTitle;
}

export function getTicketPurchaseSuccessMessage(
  ticketType: TicketType
): string {
  let message = '';
  switch (ticketType) {
    case TicketType.BuyNewCustomerGift:
      message = t('ticketused_possession_new_toast');
      break;
    case TicketType.BuyWaitFree:
      message = t('ticket_use_wuf_possession_toast');
      break;
    case TicketType.BuyTodayGift:
    case TicketType.BuyGiftFree:
      message = t('ticketused_possession_gift_toast');
      break;
    case TicketType.BuyEvent:
    case TicketType.BuyCoupon:
    case TicketType.BuyCampaign:
      message = t('ticket_use_free_possession_toast');
      break;
    /** @deprecated */
    // @no-translate
    case TicketType.BuyWaitFreePlus:
      message = '레전드패스 소장권 1장을 사용했습니다.';
      break;
    case TicketType.RentNewCustomerGift:
      message = t('ticketused_rental_new_toast');
      break;
    case TicketType.RentWaitFree:
      message = t('ticketused_wuf_toast');
      break;
    case TicketType.RentTodayGift:
    case TicketType.RentGiftFree:
      message = t('ticketused_rental_gift_toast');
      break;
    case TicketType.RentEvent:
    case TicketType.RentCoupon:
    case TicketType.RentCampaign:
      message = t('ticket_use_free_rental_toast');
      break;
    /** @deprecated */
    // @no-translate
    case TicketType.RentWaitFreePlus:
      message = '레전드패스 대여권 1장을 사용했습니다.';
      break;
    case TicketType.BuySet:
    case TicketType.RentSet:
      message = '세트이용권패키지 1장을 사용했습니다.';
      break;
    case TicketType.BuyCashSingle:
      message = '즉납형단일소장권 1장을 사용했습니다.';
      break;
    case TicketType.BuyCashDiscountSingle:
      message = '즉납형단일할인소장권 1장을 사용했습니다.';
      break;
    case TicketType.RentCashSingle:
      message = '즉납형단일대여권 1장을 사용했습니다.';
      break;
    case TicketType.RentCashDiscountSingle:
      message = '즉납형단일할인대여권 1장을 사용했습니다.';
      break;
    default:
      message =
        getTicketKindByTicketType(ticketType) === TicketKind.Own
          ? t('ticketused_possession_one_toast')
          : t('ticketused_rental_one_toast');
      break;
  }
  return message;
}
